import { React, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./ChatRoomOld.css";
import {
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemIcon,
} from "@mui/material";
import InsertEmoticonOutlinedIcon from "@mui/icons-material/InsertEmoticonOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Icon } from "@iconify/react";
import SaveIcon from "@mui/icons-material/Save";
// import AssignmentIcon from "@mui/icons-material/Assignment";
import AnnouncementIcon from "@mui/icons-material/Announcement";
// import documentIconTXT from "../Images/DocumentIconTXT.svg";
// import documentIconPDF from "../Images/DocumentIconPDF.svg";
// import documentIconDOC from "../Images/DocumentIconDOC.svg";
// import documentIconPPT from "../Images/DocumentIconPPT.svg";
// import documentIconXLS from "../Images/DocumentIconXLS.svg";
// import documentIconRAR from "../Images/DocumentIconRAR.svg";
// import documentIconZIP from "../Images/DocumentIconZIP.svg";
// import documentIconDefault from "../Images/DocumentIconDefault.svg";
// import documentIconMP3 from "../Images/DocumentIconMP3.svg";
import sent from "../Images/SingleCheckGray.svg";
import delivered from "../Images/DoubleCheckGray.svg";
import viewed from "../Images/DoubleCheckBlue.svg";
import pending from "../Images/PendingIcon.svg";
// import ReplyRoundedIcon from "@mui/icons-material/ReplyRounded";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ChatRoomBody from "./ChatRoomBody";
import ModalEndChat from "./ModalEndChat";
import ProfileInfo from "./ProfileInfo/ProfileInfo";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ResultCallModal from "../Components/ResultCallModal";
import ImagesIcon from "../Images/ImagesIcon.svg";
import videosIcon from "../Images/VideosIcon.svg";
import documentIcon from "../Images/DocumentIcon.svg";
import { getFileMedia } from "../Store/Actions/ChatAction";
import { toast } from "react-toastify";
import moment from "moment";
import EditTicketModal from "./EditTicketModal";
import AssignAgentModal from "./AssignAgentModal";
import HistoryDetailModal from "./HistoryDetailModal";
import SaveResultModal from "./SaveResultModal";
import MediaVideo from "../Images/MediaVideo.svg";
import { getResponseTemplateList } from "../Store/Actions/TicketAction";
import Loader from "../Components/Loader";
import { TextField } from "@mui/material";
import ModalHistory from "./ModalHistory";
import { getCampaignISPlan } from "../Store/Actions/CallAction";

export default function ChatRoomOld({
  contact,
  detailchat,
  message,
  myInfo,
  MfetchData,
  mhasMore,
  footerMsg,
  sendMessage,
  msgParam,
  getBase64,
  file64,
  confirmEndChat,
  readchat,
  GenerateNonPopUpFiles,
  isApp,
  viewType,
  AgentModalButton,
  textFormatter,
  selectedChat
}) {
  const emojis = [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "😂",
    "🤣",
    "😊",
    "😇",
    "🙂",
    "🙃",
    "😉",
    "😌",
    "😍",
    "😝",
    "😜",
    "🧐",
    "🤓",
    "😎",
    "😕",
    "🤑",
    "🥴",
    "😱",
  ];
  const [openModal, setOpenModal] = useState(false);
  const [optionEndChat, setOptionEndChat] = useState("");
  const [disable, setDisable] = useState(false);
  const [openPinfo, setOpenPinfo] = useState(false);
  const [chatMessage, setChatMessage] = useState("");
  const [hideEmojiDisplay, setHideEmojiDisplay] = useState(true);
  const [hideTemplateDisplay, setHideTemplateDisplay] = useState(true);
  const [hideUploadedFileDisplay, setHideUploadedFileDisplay] = useState(true);
  const [uploadFileIcon, setUploadFileIcon] = useState(null);
  const [disableInputMessage, setDisableInputMessage] = useState(false);
  const [showCampaignDetail, setShowCampaignDetail] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElMore, setAnchorElMore] = useState(null);
  const open = Boolean(anchorEl);
  const openMore = Boolean(anchorElMore);
  const [openModalTicket, setOpenModalTicket] = useState(false);
  const [openModalAssignAgent, setOpenModalAssignAgent] = useState(false);
  const [openModalSave, setOpenModalSave] = useState(false);
  const [openModalCampaignDetail, setOpenModalCampaignDetail] = useState(false);
  const [openModal_HistoryChat, setOpenModal_HistoryChat] = useState(false);
  const [ISPlan, setISPlan] = useState([]);
  const { isInCall } = useSelector((state) => state.call);

  const onFileChange = (event) => {
    getBase64(event.target.files[0]);
  };

  const confirmSendMessage = (e) => {
    e.preventDefault();

    //stop if chatMessage is empty and no file selected
    if (chatMessage.trim().length === 0 && file64.base64 === null) {
      return;
    }

    let captionBody = !disableInputMessage ? chatMessage : null;
    let filenameBody = disableInputMessage ? file64.name : null;

    let body = {
      ...msgParam,
      contactname: detailchat?.ContactName,
      number: detailchat?.MobileNo.startsWith("62")
        ? detailchat?.MobileNo
        : "62" + detailchat?.MobileNo,
      session: detailchat?.Session,
      type: file64.type !== null ? "media" : msgParam.type,
      caption: captionBody,
      filename: filenameBody,
      message: file64.base64 !== null ? file64.base64 : chatMessage,
      curChatID: detailchat?.ChatListID,
    };
    sendMessage(body);
    setChatMessage("");
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      confirmSendMessage(e);
    }
  };

  const insertEmoji = (e) => {
    InsertMessage(chatMessage + e);
  };

  const InsertMessage = (value) => {
    if (!disableInputMessage) setChatMessage(value);
  };

  const TriggerClick = (id) => {
    let el = document.getElementById(id);
    if (el.onclick) {
      el.onclick();
    } else if (el.click) {
      el.click();
    }
  };

  const isNotRead = () => {
    let idx = contact.findIndex((x) => x.ChatListID === detailchat?.ChatListID);
    if (idx > -1 && contact[idx].NotReadCount > 0)
      readchat(
        detailchat?.ChatListID,
        detailchat?.Session,
        detailchat?.MobileNo,
        detailchat?.ChatSource
      );
    return false;
  };

  const handleProfileInfo = () => {
    setDisable(true);
    setOpenPinfo(true);
  };

  const removeFile = () => {
    getBase64(null);
  };
  //========================================chatroombody function=========================================
  const [openModalMedia, setOpenModalMedia] = useState(false);
  const [selectedName, setselectedName] = useState("");
  const [Media, setMedia] = useState("");
  const [Video, setVideo] = useState("");
  const [responseTemplateList, setResponseTemplateList] = useState([]);
  const [isResponseTemplateListLoading, setIsResponseTemplateListLoading] =
    useState(true);

  useEffect(() => {
    getResponseTemplateList(9)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Response template list: ", response.data);

          setResponseTemplateList(response.data);
          setIsResponseTemplateListLoading(false);
        } else {
          console.log("error", response.error);
          setIsResponseTemplateListLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsResponseTemplateListLoading(false);
      });
  }, []);

  let idx = contact.findIndex((x) => x.ChatListID === detailchat?.ChatListID);
  const id = contact[idx];
  // const regEx = /[/]..\//g;

  const downloadOut = (fname, caption, type) => {
    getFileMedia(fname, detailchat.Session)
      .then((response) => {
        if (response.status) {
          const linkSource = response.data;
          const downloadlink = document.createElement("a");
          if (type === "document" || type === "image" || type === "video") {
            const filename = type === "document" ? caption : fname;
            downloadlink.href = linkSource;
            downloadlink.download = filename;
            downloadlink.click();
          }
        } else {
          toast.warn(response.error);
        }
      })
      .catch((err) => {
        toast.warn(err);
      });
  };

  const getMedia = (fname, session, isVideo) => {
    console.log("sessiongetmedia", session);
    getFileMedia(fname, detailchat.Session)
      .then((response) => {
        if (response.status) {
          isVideo ? setVideo(response.data) : setMedia(response.data);
        } else {
          toast.warn(response.error);
        }
      })
      .catch((err) => {
        toast.warn(err);
      });
    setselectedName(fname);
    setOpenModalMedia(true);
  };

  const statusSender = (status) => {
    let source;
    switch (status) {
      case "viewed":
        source = viewed;
        break;
      case "delivered":
        source = delivered;
        break;
      case "sent":
        source = sent;
        break;
      case "pending":
        source = pending;
        break;
      default:
        break;
    }
    if (source) {
      return (
        <span className="ChatRoombBody_status">
          <img src={source} alt={status} />
        </span>
      );
    }
  };

  // const textFormatter = (text) => {
  //   let string = text;
  //   // html formatter
  //   const htmlFormat = [
  //     { symbol: "*", tag: "b" },
  //     { symbol: "_", tag: "em" },
  //     { symbol: "~", tag: "del" },
  //     { symbol: "`", tag: "code" },
  //   ];

  //   htmlFormat.forEach(({ symbol, tag }) => {
  //     if (!string) return;
  //     const regex = new RegExp(`\\${symbol}([^${symbol}]*)\\${symbol}`);
  //     const regexfront = new RegExp(`.\\*(.*?)\\*(?!\\.)`);
  //     const skip = string.match(regexfront);
  //     if (!skip) {
  //       return string;
  //     }

  //     const match = string.match(regex);

  //     if (!match) return;

  //     match.forEach((m) => {
  //       let formatted = m;
  //       for (let i = 0; i < 2; i++) {
  //         formatted = formatted.replace(symbol, `<${i > 0 ? "/" : ""}${tag}>`);
  //       }
  //       string = string.replace(m, formatted);
  //     });
  //   });
  //   return string;
  // };

  // const renderBody = (RecordID, body, type, fName, caption, quote, preview) => {
  //   const NameRegex = /\....*/;
  //   const tempName = caption;
  //   let FileNameBody;
  //   //file64 is changed or removed

  //   if (caption) {
  //     const result = tempName.match(NameRegex);
  //     const limit = 12;
  //     FileNameBody =
  //       tempName.length > limit
  //         ? tempName.substring(0, limit) + "..." + result[0]
  //         : tempName;
  //   }

  //   let retval;
  //   const media = fName;
  //   let doctemp;
  //   if (media) {
  //     switch (media.substring(media.lastIndexOf(".") + 1)) {
  //       case "pdf":
  //         doctemp = documentIconPDF;
  //         break;
  //       case "txt":
  //         doctemp = documentIconTXT;
  //         break;
  //       case "xls":
  //       case "xlsx":
  //         doctemp = documentIconXLS;
  //         break;
  //       case "ppt":
  //       case "pptx":
  //         doctemp = documentIconPPT;
  //         break;
  //       case "doc":
  //       case "docx":
  //         doctemp = documentIconDOC;
  //         break;
  //       case "rar":
  //         doctemp = documentIconRAR;
  //         break;
  //       case "zip":
  //         doctemp = documentIconZIP;
  //         break;
  //       case "mp3":
  //       case "mpga":
  //         doctemp = documentIconMP3;
  //         break;
  //       default:
  //         doctemp = documentIconDefault;
  //     }
  //   }
  //   if (type === "document") {
  //     return (
  //       <div>
  //         <div style={{ display: "grid" }}>
  //           <img src={doctemp} alt="" className="documentcss" />
  //           <span className="ChatRoombBody_caption_reply">{FileNameBody}</span>
  //         </div>
  //       </div>
  //     );
  //   } else if (type === "video" || type === "image") {
  //     const text = body;
  //     return (
  //       <div>
  //         <div className="ChatRoombBody_image">
  //           <img
  //             src={text}
  //             alt=""
  //             onClick={() =>
  //               preview
  //                 ? null
  //                 : getMedia(
  //                     fName,
  //                     detailchat?.Session,
  //                     type === "video" ? true : false
  //                   )
  //             }
  //             className="imagecss"
  //           ></img>
  //           {caption ? (
  //             <span className="ChatRoombBody_caption">{FileNameBody}</span>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>
  //     );
  //   } else if (quote) {
  //     const ImagesQ = "data:image/jpeg;base64," + quote;
  //     let quoteTextFormat;
  //     quoteTextFormat = textFormatter(body);
  //     if (regEx.test(quote)) {
  //       return (
  //         <div>
  //           <div className="ChatRoombBody_reply">
  //             <img src={ImagesQ} alt=""></img>
  //             <ReplyRoundedIcon
  //               style={{ width: 10, height: 10, marginRight: -8 }}
  //             />
  //           </div>
  //           <div dangerouslySetInnerHTML={{ __html: quoteTextFormat }}></div>
  //         </div>
  //       );
  //     } else if (!regEx.test(quote)) {
  //       return (
  //         <div>
  //           <div className="ChatRoombBody_reply">
  //             <span className="ChatRoombBody_caption_reply">{quote}</span>
  //             <ReplyRoundedIcon
  //               style={{ width: 10, height: 10, marginRight: -8 }}
  //             />
  //           </div>
  //           <div dangerouslySetInnerHTML={{ __html: quoteTextFormat }}></div>
  //         </div>
  //       );
  //     }
  //   } else if (type === "ptt") {
  //     return (
  //       <div>
  //         <audio id={type + RecordID} controls />
  //       </div>
  //     );
  //   } else if (type === "sticker") {
  //     return (
  //       <div>
  //         <img id={type + RecordID} alt="" className="stickercss"></img>
  //         {caption ? (
  //           <span className="ChatRoombBody_caption">{caption}</span>
  //         ) : (
  //           ""
  //         )}
  //       </div>
  //     );
  //   } else {
  //     retval = textFormatter(body);
  //   }

  //   return <div dangerouslySetInnerHTML={{ __html: retval }}></div>;
  // };

  const separator = (index, date, otherDate) => {
    if (
      index.toString() === "dateseparator" ||
      index.toString() === "datefloat"
    ) {
      let text = date;
      if (date === moment.utc().format("DD MMM YYYY")) text = "Today";
      else if (date === moment.utc().add(-1, "d").format("DD MMM YYYY"))
        text = "Yesterday";
      return date === otherDate ? (
        ""
      ) : (
        <div
          className={
            index.toString() === "dateseparator" ? "DateSeparator" : "DateFloat"
          }
        >
          <span>{text}</span>
          <span className="DateSeparatorVal" style={{ display: "none" }}>
            {date}
          </span>
        </div>
      );
    } else if (id.NotReadCount > 0 && index === id.NotReadCount - 1) {
      return (
        <div className="ContainerSeparator">
          <span className="unread">Unread Message</span>
        </div>
      );
    }
  };
  const clearMedia = () => {
    setMedia("");
    setVideo("");
    setOpenModalMedia(false);
  };
  //===================================================end==================================================

  const [FileNameLong, setFileNameLong] = useState("");
  useEffect(() => {
    const NameRegex = /\.[^.]*$/;
    const tempName = file64.name;
    //file64 is changed or removed

    if (file64.name) {
      const result = tempName.match(NameRegex);
      let retval;
      const limit = 7;
      const StringName = String(tempName);
      if (StringName.length > limit) {
        const moreText = StringName.substring(0, limit) + ".." + result[0];
        retval = moreText;
      } else {
        retval = tempName;
      }
      setFileNameLong(retval);
    }

    if (file64.name === null) {
      setDisableInputMessage(false);
      setHideUploadedFileDisplay(true);
      return;
    }

    if (file64.type === "image") {
      setUploadFileIcon(ImagesIcon);
    } else if (file64.type === "video") {
      setUploadFileIcon(videosIcon);
    } else {
      setUploadFileIcon(documentIcon);
    }

    setHideUploadedFileDisplay(false);
    if (file64.type !== "image" && file64.type !== "video") {
      setChatMessage("");
      setDisableInputMessage(true);
    } else {
      setDisableInputMessage(false);
    }
  }, [file64]);

  const goback = () => {
    var e = document.getElementById("ID_Chatroom");
    if (e.style.display === "flex") e.style.display = "none";
    else e.style.display = "flex";
  };

  const ShowModalConfirmation = (option) => {
    setOpenModal(true);
    setOptionEndChat(option);
  };

  const EndSession = () => {
    return (
      <div>
        {footerMsg ? (
          <div>
            <Tooltip title="End Session" arrow>
              <IconButton
                onClick={(event) => {
                  setAnchorEl(event.currentTarget);
                }}
                aria-controls={open ? "Filter_menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <ErrorOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="endChatButton"
              open={open}
              onClose={() => setAnchorEl(null)}
              onClick={() => setAnchorEl(null)}
              transformOrigin={{ horizontal: "center", vertical: "top" }}
              anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
            >
              {renderEndSessionMenuItems()}

              <MenuItem
                sx={{
                  fontSize: "14px",
                  padding: "6px 14px",
                }}
                onClick={() => ShowModalConfirmation("endChat")}
              >
                <ListItemIcon>
                  <AnnouncementIcon />
                </ListItemIcon>
                End Chat
              </MenuItem>
            </Menu>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  const ButtonAccess = (detailchat) => {
    return (
      <div className="chatRoom_headerRight">
        {/* temp hidden */}
        {/* {!detailchat?.AssignmentID &&
        !detailchat?.CampaignID &&
        !detailchat?.OutboundContactID &&
        detailchat?.IsActive === true ? (
          myInfo.user.Level > 0 ? (
            <div className="moreDisplay">
              <Tooltip title="Assign Agent" arrow>
                <IconButton onClick={() => setOpenModalAssignAgent(true)}>
                  <PersonAddAlt1Icon />
                </IconButton>
              </Tooltip>
            </div>
          ) : (
            ""
          )
        ) : detailchat?.AssignmentID &&
          detailchat?.CampaignID &&
          detailchat?.OutboundContactID ? (
          <div className="moreDisplay">
            <Tooltip title="Campaign Detail" arrow>
              <IconButton
                onClick={() => setShowCampaignDetail(!showCampaignDetail)}
              >
                {!showCampaignDetail ? (
                  <Icon
                    icon="mdi:clipboard-text-multiple-outline"
                    color="#727272"
                  />
                ) : (
                  <Icon icon="tabler:x" color="#727272" />
                )}
              </IconButton>
            </Tooltip>
            <Tooltip title="History Detail" arrow>
              <IconButton onClick={() => setOpenModalCampaignDetail(true)}>
                <Icon icon="akar-icons:reciept" color="#727272" />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ""
        )} */}

        <div className="moreButton">
          <IconButton
            onClick={(event) => {
              setAnchorElMore(event.currentTarget);
            }}
            aria-controls={open ? "Filter_menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu
            anchorEl={anchorElMore}
            id="endChatButton"
            open={openMore}
            onClose={() => setAnchorElMore(null)}
            onClick={() => setAnchorElMore(null)}
            transformOrigin={{ horizontal: "center", vertical: "top" }}
            anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
          >
            <div style={{ display: "flex" }}>
              {!detailchat?.AssignmentID &&
              !detailchat?.CampaignID &&
              !detailchat?.OutboundContactID &&
              detailchat?.IsActive === true ? (
                myInfo.user.Level > 0 ? (
                  <div>
                    <MenuItem
                      onClick={() => setOpenModalAssignAgent(true)}
                      sx={{
                        display: "flex",
                        padding: "2px 6px",
                        fontSize: "14px",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "0px",
                        }}
                      >
                        <PersonAddAlt1Icon />
                      </ListItemIcon>
                      Assign Agent
                    </MenuItem>
                  </div>
                ) : (
                  ""
                )
              ) : detailchat?.AssignmentID &&
                detailchat?.CampaignID &&
                detailchat?.OutboundContactID ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <MenuItem
                    onClick={() => setShowCampaignDetail(!showCampaignDetail)}
                    sx={{
                      display: "flex",
                      padding: "2px 6px",
                      fontSize: "14px",
                      // padding: "6px 14px",
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0px",
                      }}
                    >
                      <Icon
                        icon="mdi:clipboard-text-multiple-outline"
                        color="#727272"
                      />
                    </ListItemIcon>
                    Campaign Detail
                  </MenuItem>

                  <MenuItem
                    sx={{
                      display: "flex",
                      padding: "2px 6px",
                      fontSize: "14px",
                    }}
                    onClick={() => setOpenModalCampaignDetail(true)}
                  >
                    <ListItemIcon
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0px",
                      }}
                    >
                      <Icon icon="akar-icons:reciept" color="#727272" />
                    </ListItemIcon>
                    History Detail
                  </MenuItem>
                </div>
              ) : (
                ""
              )}
            </div>
          </Menu>
        </div>

        {/* Temp hidden */}
        {/* <Tooltip title="Contact & Chat History" arrow>
          <IconButton
            onClick={() => handleProfileInfo()}
            className="profileButton"
            disabled={disable}
          >
            <Icon icon="mdi:card-account-details-outline" color="#727272" />
          </IconButton>
        </Tooltip> */}

        <Tooltip title="Chat History" arrow>
          <IconButton
            onClick={() => setOpenModal_HistoryChat(true)}
            disabled={openModal_HistoryChat}
          >
            <Icon icon="mdi:message-text-clock-outline" color="#727272" />
          </IconButton>
        </Tooltip>

        {EndSession()}
        {openModal ? (
          <ModalEndChat
            confirmEndChat={confirmEndChat}
            optionEndChat={optionEndChat}
            caseid={detailchat?.CaseID}
            assignmentid={detailchat?.AssignmentID}
            onClose={() => setOpenModal(false)}
            chatSource="WA"
          ></ModalEndChat>
        ) : (
          ""
        )}
      </div>
    );
  };

  const renderMedia = (type, media) => {
    if (type === "image" || type === "video") {
      return (
        <div className="previewFileOverlay">
          <CloseOutlinedIcon
            className="closeBtnMedia"
            sx={{ fontSize: 36 }}
            onClick={removeFile}
          ></CloseOutlinedIcon>
          <img src={media} alt="" className="OverlayImageContainer"></img>
        </div>
      );
    } else return "";
  };

  function renderEndSessionMenuItems() {
    const menuItems = [];

    if (
      ((selectedChat.ChatSource === "WABA" &&
        selectedChat.InitiatedBy === "AGENT") ||
        (selectedChat.ChatSource === "WA" && selectedChat.FromMe)) &&
      selectedChat.CampaignID
    ) {
      menuItems.push(
        <MenuItem
          sx={{
            fontSize: "14px",
            padding: "6px 14px",
          }}
          onClick={() =>
            getCampaignISPlan(selectedChat.CampaignID)
              .then((response) => {
                if (response.status) {
                  setISPlan(response.data);
                } else {
                  console.log("error", response.error);
                }

                setOpenModalSave(true);
              })
              .catch((err) => {
                toast.error("Error loading IS Plan", { autoClose: 3000 });
                console.log("err", err);
              })
          }
        >
          <ListItemIcon>
            <SaveIcon />
          </ListItemIcon>
          Add Interaction
        </MenuItem>
      );
    }

    if (
      (selectedChat.ChatSource === "WABA" &&
        selectedChat.InitiatedBy === "CUSTOMER") ||
      (selectedChat.ChatSource === "WA" && !selectedChat.FromMe)
    ) {
      menuItems.push(
        <MenuItem
          sx={{
            fontSize: "14px",
            padding: "6px 14px",
          }}
          onClick={() => ShowModalConfirmation("addTicket")}
        >
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          Add Ticket
        </MenuItem>
      );
    }

    return menuItems;
  }

  return (
    <div
      className="chatRoom"
      id="ID_Chatroom"
      style={{ display: "flex" }}
      onClick={() => isNotRead()}
    >
      {renderMedia(
        file64.type,
        file64.type === "video" ? MediaVideo : file64.base64
      )}
      <div className="chatRoom_header">
        <div
          className={`chatRoom_headerContainer ${isInCall && "inCall"} ${
            isInCall && openPinfo === false && "full"
          }`}
        >
          <div
            className={
              isApp() ? "chatRoom_headerInfoInApp" : "chatRoom_headerInfo"
            }
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="backButton">
                <Tooltip title="back" arrow>
                  <IconButton onClick={goback}>
                    <ArrowBackIosNewIcon />
                  </IconButton>
                </Tooltip>
              </div>

              <span className="chatRoom_headerLeft">
                <h3>{detailchat?.ContactName}</h3>
                <h4>
                  {/* {detailchat?.ChatSource === "WA"
                    ? "Whatsapp"
                    : detailchat?.ChatSource} */}

                  {detailchat?.MobileNo?.startsWith("62")
                    ? detailchat?.MobileNo
                    : "62" + detailchat?.MobileNo}

                  -

                  {detailchat?.PhoneType
                    ? detailchat.PhoneType
                    : "Mobile"}
                </h4>
              </span>
            </div>
            {ButtonAccess(detailchat)}
          </div>
        </div>

        <div
          className={
            isApp()
              ? ""
              : `Chatroom_infoHeaderSpace ${
                  isInCall && openPinfo === false && "hidden"
                }`
          }
        />
      </div>
      {openModalSave ? (
        /* <SaveResultModal
          confirmEndChat={confirmEndChat}
          AssignmentID={detailchat?.AssignmentID}
          onClose={() => setOpenModalSave(false)}
          CampaignID={detailchat?.CampaignID}
        /> */

        <ResultCallModal
          isFromChat
          isOpen={openModalSave}
          ISPlan={ISPlan}
          setIsResultCallModalShown={setOpenModalSave}
          confirmEndChat={confirmEndChat}
          chatSource={selectedChat.ChatSource}
        />
      ) : (
        ""
      )}
      {openModalTicket ? (
        <EditTicketModal
          confirmEndChat={confirmEndChat}
          onClose={() => setOpenModalTicket(false)}
        />
      ) : (
        ""
      )}
      {openModalAssignAgent ? (
        <AssignAgentModal
          detailchat={detailchat}
          AgentModalButton={AgentModalButton}
          onClose={() => setOpenModalAssignAgent(false)}
        />
      ) : (
        ""
      )}
      {openModalCampaignDetail ? (
        <HistoryDetailModal
          onClose={() => setOpenModalCampaignDetail(false)}
          OutboundContactID={detailchat?.OutboundContactID}
        />
      ) : (
        ""
      )}
      <div className={`FlexChatRoom ${openPinfo && "compact"}`}>
        <div className="GridChatRoom">
          {message.length > 0 ? (
            <ChatRoomBody
              message={message}
              MfetchData={MfetchData}
              mhasMore={mhasMore}
              statusSender={statusSender}
              downloadOut={downloadOut}
              clearMedia={clearMedia}
              separator={separator}
              GenerateNonPopUpFiles={GenerateNonPopUpFiles}
              openModalMedia={openModalMedia}
              selectedName={selectedName}
              Media={Media}
              Video={Video}
              id={id}
              detailchat={detailchat}
              showCampaignDetail={showCampaignDetail}
              isApp={isApp}
              getmedia={getMedia}
            />
          ) : (
            ""
          )}
          {footerMsg ? (
            <div className="chatRoom_footer">
              <div
                className="emojiContainer"
                style={{ display: hideEmojiDisplay ? "none" : "block" }}
              >
                <p>Emoticons</p>

                <div className="grid-container">
                  {emojis.map((e) => (
                    <button
                      className="grid-item"
                      key={e}
                      onClick={() => insertEmoji(e)}
                    >
                      {e}
                    </button>
                  ))}
                </div>
              </div>

              <div
                className="templateContainer"
                style={{ display: hideTemplateDisplay ? "none" : "block" }}
              >
                <p>Response Template</p>

                <div className="response-template-list">
                  {isResponseTemplateListLoading ? (
                    <Loader />
                  ) : (
                    responseTemplateList.map((responseTemplate) => (
                      <button
                        key={responseTemplate.TemplateID}
                        onClick={() => {
                          // Add line break after closing <p> tag
                          let strippedHTML =
                            responseTemplate.Description.replace(
                              /<\/p>/g,
                              "</p>\n"
                            );

                          // Remove all HTML tags
                          setChatMessage(strippedHTML.replace(/<[^>]+>/g, ""));
                          setHideTemplateDisplay(true);
                        }}
                      >
                        {responseTemplate.Name}
                      </button>
                    ))
                  )}
                </div>
              </div>

              <div className="inputbar_org">
                <div className="list_IconRight">
                  <input
                    id="inputFileChat"
                    type="file"
                    hidden
                    onClick={(e) => (e.target.value = null)}
                    onChange={onFileChange}
                  />
                  <IconButton
                    className="add_file"
                    onClick={() => TriggerClick("inputFileChat")}
                  >
                    <AttachFileOutlinedIcon />
                  </IconButton>
                  <IconButton
                    className="add_emote"
                    onClick={
                      () => {
                        if (
                          file64.type !== null &&
                          file64.type !== "image" &&
                          file64.type !== "video"
                        ) {
                          return;
                        } else {
                          setHideEmojiDisplay(!hideEmojiDisplay);
                          setHideTemplateDisplay(true);
                        }
                      }
                      // file64.type !== null &&
                      // file64.type !== "image" &&
                      // file64.type !== "video"
                      //   ? ""
                      //   : setHideEmojiDisplay(!hideEmojiDisplay)
                    }
                  >
                    {hideEmojiDisplay ? (
                      <InsertEmoticonOutlinedIcon />
                    ) : (
                      <Icon icon="ph:x-bold" color="#727272" />
                    )}
                  </IconButton>

                  <IconButton
                    className="add_template"
                    onClick={() => {
                      setHideEmojiDisplay(true);
                      setHideTemplateDisplay(!hideTemplateDisplay);
                    }}
                  >
                    <Icon
                      icon={
                        hideTemplateDisplay
                          ? "heroicons-outline:template"
                          : "ph:x-bold"
                      }
                      color="#727272"
                    />
                  </IconButton>
                </div>
                <form
                  className="inputbar_container"
                  style={{
                    backgroundColor:
                      file64.type !== null &&
                      file64.type !== "image" &&
                      file64.type !== "video"
                        ? "darkgrey"
                        : "inherit",
                  }}
                >
                  <span
                    className="upload_container"
                    style={{
                      display: hideUploadedFileDisplay ? "none" : "flex",
                    }}
                  >
                    <img
                      src={uploadFileIcon}
                      alt="uploadFileIcon"
                      style={{
                        width: 14,
                        height: 14,
                        paddingRight: 8,
                        paddingLeft: 8,
                        alignSelf: "center",
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignSelf: "center",
                        fontSize: 14,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {FileNameLong}
                    </span>
                    <CloseOutlinedIcon
                      className="removeUploadedFile"
                      onClick={removeFile}
                    ></CloseOutlinedIcon>
                  </span>

                  <TextField
                    className="inputbar"
                    InputLabelProps={{ shrink: false }}
                    multiline
                    placeholder="Type a message..."
                    rows={1}
                    value={chatMessage}
                    onChange={(e) => InsertMessage(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />

                  <IconButton onClick={confirmSendMessage} type="submit">
                    <SendOutlinedIcon></SendOutlinedIcon>
                  </IconButton>
                </form>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        {openModal_HistoryChat ? (
          <ModalHistory
            ChatListID={detailchat.ChatListID}
            // WAID={detailchat.MobileNo}
            onClose={() => setOpenModal_HistoryChat(false)}
          />
        ) : (
          ""
        )}

        <ProfileInfo
          open={openPinfo}
          onClose={() => {
            setOpenPinfo(false);
            setDisable(false);
          }}
          detailchat={detailchat}
          isApp={isApp}
          GenerateNonPopUpFiles={GenerateNonPopUpFiles}
        />
      </div>
    </div>
  );
}
